import styles from "./table-common.module.css";

export const SortableHeader = ({
  label,
  column,
  sortColumn,
  sortDirection,
  onSort,
}) => {
  const isActive = sortColumn === column;
  const indicator = isActive ? (sortDirection === "asc" ? " \u25B2" : " \u25BC") : "";
  const tooltip = isActive
    ? sortDirection === "asc"
      ? "Sorted ascending - click to sort descending"
      : "Sorted descending - click to clear sort"
    : "Click to sort ascending";

  return (
    <th className={styles.sortableHeader} onClick={() => onSort(column)} title={tooltip}>
      {label}
      {indicator}
    </th>
  );
};